import { FC, memo } from 'react';

import classNames from 'classnames';

import { useAccountUser } from 'application/hooks';

import IconButton from '@zvuk-b2b/react-uikit/ui/IconButton';
import IconUser from '@zvuk-b2b/react-uikit/ui/icons/User';

import styles from './index.module.scss';

const ProfileButton: FC = ({ className, onClick }: { className?: string; onClick?: () => void }) => {
  const currentUser = useAccountUser();

  return (
    <div className={styles.ProfileButtonContainer}>
      <IconButton
        key="button_user_profile"
        elementId="button_user_profile"
        className={classNames(styles.ProfileButton, className)}
        onClick={onClick}>
        {currentUser ? currentUser.email[0]?.toUpperCase() : <IconUser className={styles.ProfileButtonIcon} />}
      </IconButton>
    </div>
  );
};

export default memo(ProfileButton);
